<template>
  <v-tooltip
    bottom>
    <template
      v-slot:activator="{ on, attrs }">

      <v-btn
        :class="myClass"
        icon
        :color="color"
        v-bind="attrs"
        v-on="on"
        :disabled="disabled"
        elevation="0"
        @click="onClick"
        small>

        <v-icon
          :x-small="xsmall"
          :small="small"
          :large="large"
          :x-large="xlarge"
        >
          {{icon}}
        </v-icon>

      </v-btn>

    </template>

    <!-- RAW形式で文字列展開 -->
    <span v-html="message"></span>

  </v-tooltip>
</template>
<script>
/**
 * @file DDv2用ツールチップ付きアイコンボタン
 * @namespace components
 */

/**
 * @vue-prop {String} [message=''] - ツールチップメッセージ
 * @vue-prop {String} [icon=''] - アイコン指定
 * @vue-event {Element} click - クリックイベント
 * @see https://vuetifyjs.com/ja/api/v-icon/
 * @see https://vuetifyjs.com/ja/api/v-tooltip/
 * @description message引数はRAW形式で、タグの挿入を許可しているため、指定する際は注意すること
 * @example
 *   <dd-icon-button-with-tooltip
        v-if="item.delFlg == false"
        message="この行のコピーを作成します"
        icon="mdi-content-copy"
        @click="copyMeisaiRow(item)"/>
 */
export default {
  name: 'DdIconButtonWithTooltip',
  props: {
    addClass: {
      Type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'primary'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * ボタンサイズ
     */
    xsmall: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    xlarge: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    myClass () {
      return 'ma-0 pa-0' + ([undefined, null, ''].includes(this.addClass) ? '' : ' ' + this.addClass)
    }
  },
  methods: {
    onClick (e) {
      this.$emit('click', e)
    }
  }
}
</script>
